import React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import CancelledAppointments from "./CancelledAppointments";

const CancelledAppointmentsWidget: React.FC = () => {
  return (
    <Card sx={{ minHeight: "440px", maxHeight: "440px", display: "flex", flexDirection: "column" }}>
      <CardHeader title="Stornierungen" />
      <CardContent
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          p: 0,
          m: 0,
        }}
      >
        <CancelledAppointments />
      </CardContent>
    </Card>
  );
};

export default CancelledAppointmentsWidget;
